export default "__VITE_ASSET__kMajS3J9__"